<script>
	import { onMount } from "svelte";
	import { get } from "svelte/store";
	import { navigate } from "svelte-routing";
	import { activeMaintenanceRepairTab } from "src/store/store";
	import { isMnrPhase2Enabled } from "src/config/flag-config";
	import { vehicleTabPath } from "./tabRoutes";

	export let vehicleId;

	onMount(() => {
		const { search } = window.location;
		const tab = new URLSearchParams(search).has("addToWorkOrder")
			? 1
			: isMnrPhase2Enabled
				? get(activeMaintenanceRepairTab)
				: 1;
		navigate(`${vehicleTabPath(vehicleId, tab)}${search}`, {
			replace: true,
		});
	});
</script>
